/**
 * @generated SignedSource<<064cc515fb97321942921725beb17978>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeFundInfoserviceSection_pageSection$data = {
  readonly anchorName: string;
  readonly loginLink: string | null | undefined;
  readonly loginText: string | null | undefined;
  readonly registrationLink: string | null | undefined;
  readonly registrationText: string | null | undefined;
  readonly text: string | null | undefined;
  readonly title: string;
  readonly titleImageBackgroundUrl: string;
  readonly titleImageUrl: string;
  readonly " $fragmentType": "HomeFundInfoserviceSection_pageSection";
};
export type HomeFundInfoserviceSection_pageSection$key = {
  readonly " $data"?: HomeFundInfoserviceSection_pageSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeFundInfoserviceSection_pageSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeFundInfoserviceSection_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageBackgroundUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "loginLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "loginText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registrationText",
      "storageKey": null
    }
  ],
  "type": "HomeFundInfoservice",
  "abstractKey": null
};

(node as any).hash = "19ccfa3ed7c1ae604c42f5281b505819";

export default node;
